// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment.ts which uses `environment.ts.ts`, but if you do
// `ng build --env=prod` then `environment.ts.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    showTelemetry: false,
    apiToken: 'u1ap1k3y',
    streamUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/streaming/v2',
    stationUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/streaming/v2',
    downloadsUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/ui-svc/v1',
    subscriptionsUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/ui-svc/v1',
    audioSubscriptionsUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/ui-svc/v1',
    configUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/ui-svc/v1',
    silenceLogsUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/ui-svc',
    profileUrl: 'https://lyra-ui-connector-test.nonprod-prognplay-ihm.com/api/v1',
    redirectUri: window.location.origin + '/auth/callback',
    clientId: '87842529-e6d1-46df-b364-983a30e3a874',
    authority: 'https://login.microsoftonline.com/122a527e-5b71-4eba-878d-9810b495b9e3/',
    logoUrlPrefix: 'https://i.iheart.com/v3/re/assets/images',
    usersUrl: 'https://pp-profile-svc-dev.nonprod-prognplay-ihm.com/api/v1',
    theraptorURL: 'https://api.theraptor.org/getmappings',
    xApiKeyTheRaptor: '0iMOCyAweJ5v46Xk0SWJY6Zu8W8HUxSkargnoJeW',
    maxDownloadTime: 90,
    maxSubscriptionTime: 90,
    defaultSubscriptionTime: 5,
    featureToggle: [
        {
            enabled: true,
            name: 'LINEAR_PLAYOUT_TOGGLE',
            friendlyName: 'Toggle to enable/disable linear playout ',
            jiraCard: 'SIA-3570'
        },
        {
            enabled: true,
            name: 'SUBSCRIPTIONS_TOGGLE',
            friendlyName: 'Toggle to enable/disable Subscriptions ',
            jiraCard: 'SIA-3590'
        },
        {
            enabled: true,
            name: 'AUDIO_SEGMENT_TOGGLE',
            friendlyName: 'Toggle to enable/disable Audio Segment ',
            jiraCard: 'SIA-4413'
        }

    ],
    downloadPaddingInSeconds: 5,
    wavesurferZoom: 2.5,
    orgId : 'o-1HC1TE-na1'

};
